<template>
  <div class="c-cards__item">
    <div class="card-image" v-if="fields && fields.image">
      <sc-image v-if="fields && fields.image" :media="fields.image" />
    </div>
    <div class="card-content" v-if="fields && fields.content" v-html="fields.content.value" />
    <sc-link
      v-if="fields && fields.cta"
      :field="fields.cta"
      class="c-cta--secondary"
      :class="fields.cta.value.class"
    >
      {{ fields?.cta?.value?.text }}
      <span class="sr-only">{{ fields?.name?.value }}</span>
    </sc-link>
    <button
      aria-label="Expand"
      class="card-expand"
      v-if="fields && fields.name"
      @click="smallModal = true"
    />
    <template v-if="isEditing">
      <div class="c-modal">
        <button
          class="c-modal__close"
          v-if="fields && fields.name"
          @click="close(fields.name.value)"
        >
          X
        </button>
        <sc-text
          tag="h2"
          class="c-modal__title"
          v-if="fields && fields.modalTitle"
          :field="fields.modalTitle"
        />
        <sc-rich-text
          tag="div"
          class="c-modal__content"
          v-if="fields && fields.modalContent"
          :field="fields.modalContent"
        />
        <sc-link
          v-if="fields && fields.modalCta"
          :field="fields.modalCta"
          class="c-cta--secondary"
          :class="fields.modalCta.value.class"
        />
      </div>
    </template>
    <template v-else>
      <VueFinalModal
        v-model="smallModal"
        class="final-modal smallModal"
        :class="{ scroll: isScrollable }"
        content-class="final-modal-content"
        content-transition="vfm-fade"
        overlay-transition="vfm-fade"
      >
        <div ref="modalContent" class="c-modal">
          <div class="c-modal__content">
            <button class="c-modal__close" v-if="fields && fields.name" @click="smallModal = false">
              X
            </button>
            <sc-text
              tag="h2"
              class="c-modal__title"
              v-if="fields && fields.modalTitle"
              :field="fields.modalTitle"
            />
            <sc-rich-text
              tag="div"
              v-if="fields && fields.modalContent"
              :field="fields.modalContent"
            />
            <sc-link
              v-if="fields && fields.modalCta"
              :field="fields.modalCta"
              class="c-cta--secondary"
              :class="fields.modalCta.value.class"
              xv-html="`${fields.modalCta.value.text}`"
            />
          </div>
        </div>
      </VueFinalModal>
    </template>
  </div>
</template>

<script>
import { Text, Image, Link, RichText } from '@sitecore-jss/sitecore-jss-vue';
import { ref, reactive } from 'vue';
import { useWindowSize, useElementSize } from '@vueuse/core';
import { VueFinalModal } from 'vue-final-modal';
import 'vue-final-modal/style.css';

export default {
  name: 'CIS-Home-Card-Item',
  components: {
    ScText: Text,
    ScImage: Image,
    ScLink: Link,
    ScRichText: RichText,
    VueFinalModal
  },
  props: {
    fields: {
      type: Object
    }
  },
  setup() {
    // Window Height
    const { height } = useWindowSize();
    // Small Modal
    const smallModal = ref(false);
    // Modal Content
    const modalContent = ref(null);
    // Get Modal Content Size
    const modalSize = reactive(useElementSize(modalContent));

    return {
      height,
      smallModal,
      modalContent,
      modalSize
    };
  },
  computed: {
    isEditing() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the `sitecoreContext` provided in layout service data.
      return this.$jss.sitecoreContext().pageEditing;
    },
    isScrollable() {
      return this.modalSize?.height > this.height;
    }
  }
};
</script>
